import { z } from "zod";
import { baseEntitySchema } from "./base";

// An outgoing PayPal payment pulled in by the read-only sync, held in an inbox
// to be reconciled against a purchase order. "suggested" = the sync found a
// likely PO by email + amount; "matched" = an admin confirmed (or manually
// picked) the PO; "rejected" = an admin dismissed it; "unmatched" = no suggestion.
export const paypalPaymentMatchStatusSchema = z.enum([
  "unmatched",
  "suggested",
  "matched",
  "rejected",
]);
export type PaypalPaymentMatchStatus = z.infer<
  typeof paypalPaymentMatchStatusSchema
>;

export const paypalPaymentDataSchema = z.object({
  transactionId: z.string(),
  amount: z.number().nonnegative(),
  currency: z.string().default("USD"),
  feeValue: z.number().nonnegative().default(0),
  // "outgoing" = money we sent; "incoming" = money received. The sync currently
  // ingests only outgoing; stored for forward-compatible filtering.
  direction: z.enum(["outgoing", "incoming"]).optional(),
  counterpartyEmail: z.string().optional(),
  counterpartyName: z.string().optional(),
  paidAt: z.date().optional(),
  eventCode: z.string().optional(),
  paypalStatus: z.string().optional(),
  note: z.string().optional(),
  invoiceId: z.string().optional(),
  customField: z.string().optional(),
  matchStatus: paypalPaymentMatchStatusSchema,
  suggestedPoId: z.string().optional(),
  suggestionMismatchPct: z.number().optional(),
  matchedPoId: z.string().optional(),
  matchedPaymentId: z.string().optional(),
  matchedAt: z.date().optional(),
  matchedByUserId: z.string().optional(),
});

export type PaypalPaymentData = z.infer<typeof paypalPaymentDataSchema>;
export const paypalPaymentSchema = baseEntitySchema.merge(
  paypalPaymentDataSchema,
);
export type PaypalPayment = z.infer<typeof paypalPaymentSchema>;
